/**
 * Creative Templates Configuration
 * Templates for different ad formats and styles
 */

// Creative templates for image generation
export const CREATIVE_TEMPLATES = [
  {
    id: 'gradient-bottom',
    name: 'Degradado Inferior',
    description: 'Headline en tercio inferior',
    preview: 'linear-gradient(180deg, #1a1a2e 0%, #16213e 50%, #0f3460 100%)',
    safe_zone: 'bottom-third',
    motor: 'flux_pro'
  },
  {
    id: 'clean-top',
    name: 'Espacio Superior',
    description: 'Headline arriba',
    preview: 'linear-gradient(0deg, #667eea 0%, #764ba2 100%)',
    safe_zone: 'top-third',
    motor: 'flux_pro'
  },
  {
    id: 'brand-gradient',
    name: 'Colores de Marca',
    description: 'Usa tu paleta',
    preview: 'linear-gradient(135deg, var(--primary) 0%, var(--secondary) 100%)',
    safe_zone: 'bottom-third',
    motor: 'nano_banana'
  },
  {
    id: 'illustration-flat',
    name: 'Ilustración',
    description: 'Estilo flat/vector',
    preview: 'linear-gradient(135deg, #84fab0 0%, #8fd3f4 100%)',
    safe_zone: 'bottom-third',
    motor: 'seedream'
  },
  {
    id: 'story-vertical',
    name: 'Story 9:16',
    description: 'Formato vertical',
    preview: 'linear-gradient(180deg, #0f0c29 0%, #302b63 50%, #24243e 100%)',
    safe_zone: 'bottom-quarter',
    motor: 'flux_pro',
    aspect_ratio: '9:16'
  }
];

// Motor (AI model) options for image generation
export const MOTORES_IMAGEN = [
  {
    id: 'flux_pro',
    nombre: 'Flux Pro',
    descripcion: 'Alta calidad, versátil',
    creditos: 11,
    recommended: true,
    family: 'text-to-image'
  },
  {
    id: 'flux_schnell',
    nombre: 'Flux Schnell',
    descripcion: 'Rápido, borradores',
    creditos: 6,
    recommended: false,
    family: 'text-to-image'
  },
  {
    id: 'nano_banana',
    nombre: 'Nano Banana',
    descripcion: 'Integra logos, edición',
    creditos: 6,
    recommended: false,
    family: 'edit'
  },
  {
    id: 'seedream',
    nombre: 'Seedream V4',
    descripcion: 'Ilustraciones, arte',
    creditos: 8,
    recommended: false,
    family: 'text-to-image'
  },
  {
    id: 'gpt_image',
    nombre: 'GPT Image',
    descripcion: 'OpenAI, realista',
    creditos: 10,
    recommended: false,
    family: 'text-to-image'
  }
];

// Type of anuncio (ad) options
export const TIPO_ANUNCIO = [
  {
    id: 'generar_imagen',
    nombre: 'Generar imagen con IA',
    descripcion: 'Elige entre varios motores de IA',
    icon: 'Sparkles',
    creditos: 11,
    badge: 'Recomendado'
  },
  {
    id: 'subir_imagen',
    nombre: 'Subir imagen propia',
    descripcion: 'Tu imagen + headline',
    icon: 'Upload',
    creditos: 12
  },
  {
    id: 'subir_video_subtitulos',
    nombre: 'Subir video + subtítulos',
    descripcion: 'Video con texto overlay',
    icon: 'FileVideo',
    creditos: 12
  },
  {
    id: 'subir_video_voz',
    nombre: 'Subir video + voz IA',
    descripcion: 'Video con narración',
    icon: 'Mic',
    creditos: 22
  },
  {
    id: 'avatar_ia',
    nombre: 'Avatar IA hablando',
    descripcion: 'Voz + Video',
    icon: 'UserCircle',
    creditos: 45
  }
];

// Helper to get recommended motor based on brief
export const getRecommendedMotor = (brief, selectedTemplate) => {
  // If logo available and using brand template, recommend Nano Banana
  const hasLogo = brief?.project_logo || brief?.logo_url || brief?.marca_logo_url;
  const isBrandTemplate = selectedTemplate?.id === 'brand-gradient';
  
  if (hasLogo && isBrandTemplate) {
    return 'nano_banana';
  }
  
  // If illustration style, recommend Seedream
  const style = (brief?.marca_estilo_visual || '').toLowerCase();
  if (style.includes('ilustr') || style.includes('vector') || style.includes('flat')) {
    return 'seedream';
  }
  
  // Default to Flux Pro for best quality
  return 'flux_pro';
};

export default CREATIVE_TEMPLATES;
